import * as url from "../url.helper";

import { post } from "../api.helper";

export const getPermissionList = data => post(url.GET_ROLEPERMISSION_LIST, data);

export const updatePermissionList = data => post(url.EDIT_ROLEPERMISSION_LIST , data)

export const getPermissionFields = data => post(url.GET_PERMISSION_FIELDS, data);

export const addPermissionList = data => post(url.ADD_PERMISSION_LIST, data);
